// entry point for `web`
// entry point for `react-native` is `../index.js`
import { AppRegistry, Platform } from 'react-native';

import { App } from './App';

import appJson from '../app.json';

AppRegistry.registerComponent(appJson.name, () => App);

if (Platform.OS === 'web') {
  AppRegistry.runApplication(appJson.name, {
    rootTag: document.getElementById('root'),
  });
}
